import { render, staticRenderFns } from "./LinkEntry.vue?vue&type=template&id=5c904e1c&scoped=true&"
import script from "./LinkEntry.vue?vue&type=script&lang=js&"
export * from "./LinkEntry.vue?vue&type=script&lang=js&"
import style0 from "./LinkEntry.vue?vue&type=style&index=0&id=5c904e1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c904e1c",
  null
  
)

export default component.exports